import React, { useState } from "react";
import { Grid, Typography, Container, Button } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link } from "react-router-dom";
import { Parallax } from "react-parallax";
import { Box } from "@mui/material";
import Highlighter from "react-highlight-words";

const Footer = () => {

    const mockData = {
        web_settings: [
            {
                logo: "/assets/images/kblogo.png",
                app_short_description: "Welcome to KulaBox, your one-stop-shop for all your daily needs. We offer a range of services, including food delivery, grocery delivery, and taxi booking!",
                address: "123 Main Street, Nairobi, Kenya",
                support_email: "support@kulabox.com",
                copyright_details: "&copy; 2024 KulaBox. All rights reserved.",
                facebook_link: "https://facebook.com/example",
                instagram_link: "https://instagram.com/example",
                youtube_link: "https://youtube.com/example",
                twitter_link: "https://twitter.com/example",
            },
        ],
    };





    return (
        <Box mt={5}>
            <div
                className="header-wrapper" style={{ height: "790px" }}>

            
                <Container>
                    <div className="footer-wrapper">
                        <Grid container spacing={3} justifyContent="flex-start">
                            <Grid item md={3}>
                                <div className="footer-logo-wrapper">
                                    {/* <div className="footer-logo">
                                        <img src={mockData.web_settings[0].logo} alt="logo" />
                                    </div> */}
                                    <Typography color="#fff">
                                        {mockData.web_settings[0].app_short_description}
                                    </Typography>
                                </div>
                            </Grid>

                            <Grid item md={3}>
                                <div className="footer-services-wrapper">
                                    <Typography color="#fff" variant="h6">
                                        <Highlighter
                                            highlightClassName="highlight"
                                            searchWords={["learn"]}
                                            autoEscape={true}
                                            textToHighlight="Learn More"
                                        />
                                    </Typography>
                                    <ul>
                                        <li>
                                            <Typography component={Link} to="/privacy">
                                                Privacy Policy
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography component={Link} to="/terms-conditions">
                                                Terms & Conditions
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography component={Link} to="/contact-us">
                                                Contact Us
                                            </Typography>
                                        </li>
                                    </ul>

                                </div>
                            </Grid>



                            <Grid item md={3}>
                                <div className="contactUs-wrapper">
                                    <Typography color="#fff" variant="h6">
                                        <Highlighter
                                            highlightClassName="highlight"
                                            searchWords={["contact", "संपर्क"]}
                                            autoEscape={true}
                                            textToHighlight="Contact Us"
                                        />
                                    </Typography>
                                    <Typography color="#fff" dangerouslySetInnerHTML={{ __html: mockData.web_settings[0].address }} />
                                    <Typography color="#fff">{mockData.web_settings[0].support_email}</Typography>
                                </div>
                            </Grid>
                            <Grid item md={3}>
                                <div className="download-buttons">
                                    <Typography color="#fff" variant="h6">
                                        Download Apps
                                    </Typography>
                                    <a href={mockData.web_settings[0].playstore_link} target="_blank" rel="noreferrer">
                                        <img src="/assets/images/playstore.png" alt="Download from Play Store" style={{ width: "150px", marginTop: "10px" }} />
                                    </a>
                                    <a href={mockData.web_settings[0].appstore_link} target="_blank" rel="noreferrer">
                                        <img src="/assets/images/appstoere.png" alt="Download from App Store" style={{ width: "150px", marginTop: "10px" }} />
                                    </a>
                                </div>
                            </Grid>
                            <Grid item md={3}>
                                <div className="footer-services-wrapper">
                                    <Typography color="#fff" variant="h6">
                                        <Highlighter
                                            highlightClassName="highlight"
                                            searchWords={["contact", "संपर्क"]}
                                            autoEscape={true}
                                            textToHighlight="Partner With Us"
                                        />
                                    </Typography>
                                    <ul>
                                        <li><Link to="/privacy"><Typography>Become a seller</Typography></Link></li>
                                        <li><Link to="/terms-conditions"><Typography>Become a driver</Typography></Link></li>
                                    </ul>
                                </div>
                            </Grid>


                        </Grid>
                    </div>

                    <div className="footer-bottom">
                        <Grid container spacing={2}>
                            <Grid item md={6}>
                                <Typography color="#fff" variant="subtitle1">
                                    <span dangerouslySetInnerHTML={{ __html: mockData.web_settings[0].copyright_details }} />
                                </Typography>
                            </Grid>
                            <Grid item md={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                <div className="social-icons">
                                    <a href={mockData.web_settings[0].facebook_link} target="_blank" rel="noreferrer"><FacebookIcon /></a>
                                    <a href={mockData.web_settings[0].instagram_link} target="_blank" rel="noreferrer"><InstagramIcon /></a>
                                    <a href={mockData.web_settings[0].youtube_link} target="_blank" rel="noreferrer"><YouTubeIcon /></a>
                                    <a href={mockData.web_settings[0].twitter_link} target="_blank" rel="noreferrer"><TwitterIcon /></a>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </div>

        </Box>
    );
};

export default Footer;
